// extracted by mini-css-extract-plugin
export default {"NotifBox":"NotifBrowserBox_NotifBox__t-SWI","react-draggable":"NotifBrowserBox_react-draggable__eI4P5","cursor":"NotifBrowserBox_cursor__bzjR5"};